import { PageHero, Reveal, SectionHead, PhotoFrame, EmptyState } from "@/components/Shared";
import { IMG, usePageContent } from "@/lib/api";
import { PAGES } from "@/content/pageContent";

export default function Collaborators() {
  const c = usePageContent("collaborators", PAGES.collaborators.defaults);
  return (
    <main>
      <PageHero eyebrow="Stronger Together" title="Our Collaborators" italic="& Sponsors" image={IMG.celestialSky}>
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          {c.heroText}
        </p>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-24" data-testid="collaborators-section">
        {c.groups.map((g, gi) => (
          <div key={`${g.title}-${gi}`} className="mb-16 last:mb-0" data-testid={`collaborator-group-${gi}`}>
            <SectionHead eyebrow={g.title} grotesk />
            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {g.items.map((item, i) => {
                const [name, logo] = String(item).split("|").map((s) => s.trim());
                return (
                  <Reveal key={`${g.title}-${i}`} delay={i * 0.07} className="h-full">
                    <div className="card-line flex h-full flex-col items-center p-6 text-center" data-testid={`collaborator-card-${gi}-${i}`}>
                      <PhotoFrame src={logo || null} label="Logo coming soon" className="aspect-square w-full bg-navy" />
                      <p className="mt-5 font-grotesk text-lg font-semibold tracking-tight text-silver">{name}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        ))}
        <Reveal>
          <div className="mt-6">
            <EmptyState title={c.emptyTitle} note={c.emptyNote} />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
